import { FeatureToggle, TestType } from 'featureToggles';
import { getQuery } from 'utils/queryUtils';
import { optimizelyInstance } from './OptimizelyProvider';

export const timeout = 900; // Optimizely instance timeout for fetching data

export type Experiment = {
  name: string;
  variation: string;
};

export const getQueryParam = (toggleKey: FeatureToggle, testType: TestType) => {
  return testType === TestType.AB
    ? getQuery().get(`enable${toggleKey}`)
    : getQuery().get(`variation${toggleKey}`);
};

export const getOptimizelyQueryValue = () => {
  const queryValue = getQuery().get('optimizely');

  try {
    const split = queryValue!.split('/');
    const [name, variation] = split;

    if (name && variation) {
      return { name, variation };
    }
  } catch {
    // pass
  }

  return null;
};

export const isExperimentValueReady = () =>
  !!(getOptimizelyQueryValue() || optimizelyInstance.isReady());

export const generateUserId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getUserId = () => {
  let userId = localStorage.getItem('optimizely.userId');
  if (!userId) {
    userId = generateUserId();
    localStorage.setItem('optimizely.userId', userId);
  }
  return userId;
};

export const getExperimentSync = () => {
  const queryValue = getOptimizelyQueryValue();

  if (queryValue) return queryValue;

  const experiments = optimizelyInstance
    .getEnabledFeatures()
    .map(key => ({
      name: key,
      variation: optimizelyInstance.getVariation(key)
    }))
    .filter(t => t.variation !== null) as Experiment[];

  // Only allow one enabled feature
  return experiments[0] ?? null;
};

export const getExperiment = async () => {
  if (!isExperimentValueReady()) {
    await optimizelyInstance.onReady({ timeout });
  }

  return getExperimentSync();
};
